import { Config } from '@catalogo/core-configuration';
import { PageLoadEvent, ExperimentExposureEvent } from '../../../types/events';
import { ExperimentExposureDatalayerEvent } from '../../../types/datalayer/experiment-exposure';
import { eventData } from '../../../types/datalayer/datalayer';
import getDefaultEventPayload from '../default-event';

export default (events: eventData, config: Config): void => {
  const pageload = events['page:load'][0] as PageLoadEvent;
  const exps = events['experiment:exposure'].map(event => {
    const e = event as ExperimentExposureEvent;
    const experimentId = e?.detail?.experiment?.experimentId;
    const variant = e?.detail?.experiment?.variant;
    return `${experimentId}:${variant}`;
  });
  const defaultEventPayload = getDefaultEventPayload(pageload, config);

  const event = {
    ...defaultEventPayload,
    event: 'experiment_exposure',
    eventCategory: 'teste-ab',
    action: 'experiment_exposure',
    testsAB: exps.join('|'),
    eventAction: 'experiment_exposure',
    eventLabel: undefined,
    eventValue: undefined,
  } as ExperimentExposureDatalayerEvent;

  window.dataLayer = window.dataLayer || [{}];
  window.dataLayer.push(event);
};
